// extracted by mini-css-extract-plugin
export default {"page":"extension-report_page__Y6udu"};